'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function BrandGamespotLogoLight(props) {
    return (React__namespace.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", width: "1em", height: "1em" }, props),
        React__namespace.createElement("rect", { width: 20, height: 20, fill: "#fff", rx: 10 }),
        React__namespace.createElement("path", { fill: "#EB442E", d: "M10 2c-4.419 0-8 3.588-8 8.014 0 4.427 3.581 8.015 8 8.015 4.419 0 8-3.588 8-8.015C18 5.588 14.419 2 10 2zm0 14.986c-3.844 0-6.96-3.121-6.96-6.972 0-3.85 3.116-6.974 6.96-6.974s6.96 3.122 6.96 6.972c0 3.85-3.116 6.974-6.96 6.974z" }),
        React__namespace.createElement("path", { fill: "#EB442E", d: "M13.113 13.094c-.181-.127-.424-.184-.69-.184-.209 0-.738.085-1.564.256-.435.094-.77.123-1.008.123a3.49 3.49 0 01-2.453-.95c-.663-.643-1.01-1.416-1.01-2.32 0-.927.325-1.702 1.005-2.324.698-.644 1.579-.957 2.65-.957.702 0 1.258.048 1.717.164.07.013.42.127 1.04.355l-.253.97c-.31-.127-.54-.2-.709-.234a3.675 3.675 0 00-1.01-.136c-.697 0-1.244.221-1.655.663-.38.406-.557.914-.557 1.505 0 .585.17 1.063.518 1.455.354.398.77.571 1.25.571.186 0 .35-.028.477-.144a.592.592 0 00.197-.456v-1.327h2.057v2.97h-.002z" })));
}

module.exports = BrandGamespotLogoLight;
